import { useClientSettings } from "@hooks/useClientSettings";

import { Image } from "./styles";

type LogoProps = {
  icon?: boolean;
  type?: "white" | "colored" | "black";
};

export const Logo = ({ icon, type = "colored" }: LogoProps) => {
  const client = useClientSettings();
  const url = (() => {
    if (icon) {
      return client.assets.favicon;
    }
    return client.assets.logo;
  })();

  return <Image src={url} alt="Logo" type={type} />;
};
